export default {
    path: '/return-policy',
    name: 'Return-Policy',
    meta: {
        title: 'Правила возврата',
        forVisitors: true
    },
    component: () => import('@/views/info_pages/return_policy'),
}